module.exports = __webpack_public_path__ + "img/heat-meter-temperature-sm.b5de2564.svg";